var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-error"},_vm._l((_vm.errors),function(err){return _c('p',{key:err,staticClass:"form-memo"},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_c('span',[_vm._v(_vm._s(err))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }